import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { reaction } from 'mobx';
import { RendleyStore } from '../../../../store/RendleyStore';
import LibrettoClip from '../LibrettoClip/LibrettoClip';

interface LibrettoTextClipProps {
    librettoClipId: string;
    layerId: string;
}

export const LibrettoTextClip: React.FC<LibrettoTextClipProps> = observer(({ librettoClipId, layerId }) => {
    const [text, setText] = useState<string | undefined>();

    useEffect(() => {
        const disposer = reaction(
            () => {
                const librettoClipState = RendleyStore.getLibrettoClipState(librettoClipId);
                return librettoClipState;
            },
            (librettoClipState) => {
                if (!librettoClipState.combinedProperties) {
                    setText(undefined);
                    return;
                }

                const { combinedProperties } = librettoClipState;
                const firstClipId = combinedProperties.firstClipId;
                
                setText(RendleyStore.getTextByClipId(firstClipId));
            },
            { fireImmediately: true }
        );
        
        return () => { disposer(); };
    }, [librettoClipId]);

    return (
        <LibrettoClip librettoClipId={librettoClipId} layerId={layerId} filename={text || 'Text'} backgroundColor={"118, 100, 233"}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 3.5V2H10V3.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.5 10H7.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 2V10"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </LibrettoClip>
    );
});

export default LibrettoTextClip;
